import * as React from 'react';
import { ICenterBase, IListItem } from '@nkr/models/index';
import { Button, FormControl, InputGroup, Well } from 'react-bootstrap';

interface IProps {
    centerId: number,
    center: number,
    status: number,
    firstName: string,
    lastName: string,
    alias: string,
    email: string,
    isAdmin: boolean,
    donorId: number,
    centerList: ICenterBase[],
    onUpdateSearch: (center: number, status: number, firstName: string, lastName: string, alias: string, email: string) => void,
    onSearch: () => void,
    onReset: () => void,
}

const Search = (props: IProps) => {
    const handleFieldChange = (e: React.ChangeEvent<FormControl & HTMLInputElement>) => {
        let { center, status, firstName, lastName, alias, email } = props;

        let id = e.currentTarget.id;

        switch (id) {
            case 'center': center = parseInt(e.currentTarget.value); break;
            case 'status': status = parseInt(e.currentTarget.value); break;
            case 'firstName': firstName = e.currentTarget.value; break;
            case 'lastName': lastName = e.currentTarget.value; break;
            case 'alias': alias = e.currentTarget.value; break;
            case 'email': email = e.currentTarget.value; break;
        }

        props.onUpdateSearch(center, status, firstName, lastName, alias, email);
    };

    const handleSearch = () => {
        props.onSearch();
    }

    const handleReset = () => {
        props.onReset();
    }

    return (
        <Well style={{ paddingTop: 9, paddingBottom: 9 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {props.isAdmin && (
                        <div style={{ marginRight: 20 }}>
                            <div style={{ marginRight: 5 }}>Center</div>
                            <div>
                                <FormControl
                                    componentClass='select'
                                    id='center'
                                    value={props.center}
                                    onChange={handleFieldChange}
                                >
                                    <option value={0}>- ALL -</option>
                                    {props.centerList.map((item, index) =>
                                        <option key={'ctr-' + index} value={item.id}>{item.alias}</option>
                                    )}
                                </FormControl>
                            </div>
                        </div>
                    )}

                    <div style={{ marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>Status</div>
                        <div>
                            <FormControl
                                componentClass='select'
                                id='status'
                                value={props.status}
                                onChange={handleFieldChange}
                            >
                                <option value={-1}>- ALL -</option>
                                <option value={0}>Available</option>
                                <option value={1}>Unavailable</option>
                            </FormControl>
                        </div>
                    </div>

                    <div style={{ marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>First Name</div>
                        <div>
                            <InputGroup>
                                <FormControl
                                    id='firstName'
                                    placeholder='e.g. J OR John'
                                    value={props.firstName}
                                    onChange={handleFieldChange}
                                />
                            </InputGroup>
                        </div>
                    </div>

                    <div style={{ marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>Last Name</div>
                        <div>
                            <InputGroup>
                                <FormControl
                                    id='lastName'
                                    placeholder='e.g. D OR Doe'
                                    value={props.lastName}
                                    onChange={handleFieldChange}
                                />
                            </InputGroup>
                        </div>
                    </div>

                    <div style={{ marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>Donor Alias</div>
                        <div>
                            <InputGroup>
                                <FormControl
                                    id='alias'
                                    value={props.alias}
                                    onChange={handleFieldChange}
                                />
                            </InputGroup>
                        </div>
                    </div>

                    <div style={{ marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>Email</div>
                        <div>
                            <InputGroup>
                                <FormControl
                                    id='email'
                                    placeholder='e.g. joh OR john.doe@example.com'
                                    value={props.email}
                                    onChange={handleFieldChange}
                                />
                            </InputGroup>
                        </div>
                    </div>

                    <div style={{ marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>&nbsp;</div>
                        <div>
                            <Button bsStyle='primary' style={{ marginRight: 5 }} onClick={handleSearch}>Search</Button>
                            <Button onClick={handleReset}>Reset</Button>
                        </div>
                    </div>
                </div>

                {props.donorId != null && (
                    <div>
                        <div>
                            <div style={{ marginRight: 5 }}>&nbsp;</div>
                            <div>
                                <Button bsStyle='success' href={'/center/' + props.centerId + '/donor/' + props.donorId + '/voucher-holder/add'}>Add Voucher Holder</Button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Well>
    )
}

export default Search;